import React from 'react';
import "./index.css";
import imghotel from '../../../assets/hotel2.png';
import imgplane from '../../../assets/plane2.png';
import imgtrain from '../../../assets/train2.png';

import iconhotel from '../../../assets/hotel3.png';
import iconplane from '../../../assets/plane3.png';
import icontrain from '../../../assets/train.png';
import imgedit from '../../../assets/edit.png';
import imgeye from '../../../assets/eye.png';

export default (props: any) => {
  const { canEdit, title, type, edit, onEdit, time, status, statusColor, onClick } = props;

  const editClick = (e: any) => {
    e.stopPropagation();
    onEdit();
  }

  const titleIcon = type === 'hotel'
    ? iconhotel
    : type === 'train'
      ? icontrain
      : iconplane;

  const cardImg = type === 'hotel'
    ? imghotel
    : type === 'train'
      ? imgtrain
      : imgplane;

  return (
    <div className='mine-card' onClick={onClick}>
      <div style={{  position: 'relative' }}>
        <div className='mine-card-content'>

          <div className='mine-card-title'>
            <div className='mine-card-title-icon mine-card-common-img' style={{ backgroundImage: `url(${titleIcon})` }} />
            <span>{title}</span>
          </div>

          <div className='mine-card-status' style={{ color: statusColor ? statusColor : '#0D59C8' }}>{status}</div>
          <div style={{color: 'gray', maxWidth: '85%'}}>
            {props.children}
          </div>
          
          <div style={{ width: '100%', height: '5px' }} />

          <div className='mine-card-time'>{time}</div>
        </div>
        
        {type && (
          <img
            className='mine-card-icon'
            src={cardImg}
          />
        )}
      </div>

      <div className='mine-card-bar'>
        {edit ? (
          <div
            className='mine-card-edit'
          >
            <div className='mine-card-edit-icon' style={{ backgroundImage: `url(${imgedit})` }} />
            <span>{edit}</span>
          </div>
        ) : (
            <div
              className='mine-card-edit'
            >
              <div className='mine-card-edit-icon' style={{ backgroundImage: `url(${imgeye})` }} />
              <span>查看</span>
            </div>
        )}
      </div>
      
    </div>
  )
}